import styled, { css } from 'styled-components';

import { MaskInput } from '@hero/atoms';

const ColumnMaskInputWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 4px;
  margin-top: 4px;
  min-height: 40px;
  min-width: 140px;

  ${({ readOnly, isFocused }) => css`
    ${!readOnly && 'cursor: pointer;'}

    ${(!isFocused || readOnly) &&
    css`
      padding: 0 16px;
      ${!readOnly &&
      css`
        &:hover {
          border-radius: var(--size-border-radius-md);
          outline: 1px solid var(--color-border-default);
        }
      `}
    `}
  `}
`;

export const ColumnMaskInput = ({
  onFocus,
  isFocused,
  readOnly,
  columnProps,
  error,
  value,
  ...props
}) => {
  return (
    <ColumnMaskInputWrapper
      readOnly={readOnly}
      onClick={onFocus}
      isFocused={isFocused}
      error={error}
      columnProps={columnProps}
    >
      {!isFocused || readOnly ? (
        <>{value ? columnProps?.componentProps?.formatPreview?.(value) || value : <p>⎯</p>}</>
      ) : (
        <MaskInput value={value} isFocused={isFocused} {...props} {...columnProps.componentProps} />
      )}
    </ColumnMaskInputWrapper>
  );
};
